'use client';

import 'react-lazy-load-image-component/src/effects/blur.css';
import classes from './Carousel.module.css';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { useEffect, useState } from 'react';

const ChevronCarousel = ({ listing }) => {
	const [current, setCurrent] = useState(0);
	const [currentpage, setCurrentpage] = useState(0);

	const nextHandler = () => {
		const imageElement = document?.getElementById('carousel-image');

		let newNum = current === listing.images.length - 1 ? 0 : current + 1;

		setCurrent(newNum);
		imageElement.src = `${listing.images[newNum]}?tr=w-876,h-1134,c-at_max_enlarge`;

		imageElement.setAttribute('currentindex', newNum);

		if (newNum === 0) {
			setCurrentpage(0);
			imageElement.setAttribute('currentpage', 0);
		} else if (
			(current === 5 && currentpage === 0) ||
			(current === 11 && currentpage === 1) ||
			(current === 17 && currentpage === 2) ||
			(current === 23 && currentpage === 3)
		) {
			setCurrentpage(currentpage + 1);
			imageElement.setAttribute('currentpage', currentpage + 1);
		}
	};
	const previousHandler = () => {
		const imageElement = document?.getElementById('carousel-image');

		let newNum = current - 1;
		setCurrent(newNum);
		imageElement.src = `${listing.images[newNum]}?tr=w-876,h-1134,c-at_max_enlarge`;
		imageElement.setAttribute('currentindex', newNum);

		if (
			(current === 6 && currentpage === 1) ||
			(current === 12 && currentpage === 2) ||
			(current === 18 && currentpage === 3) ||
			(current === 24 && currentpage === 4)
		) {
			imageElement.setAttribute('currentpage', currentpage - 1);
		}
	};

	useEffect(() => {
		const imageElement = document.getElementById('carousel-image');

		if (!imageElement) return;

		// Create a MutationObserver to listen for changes to the `src` attribute
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.attributeName === 'currentindex') {
					const currentVal = imageElement.getAttribute('currentindex');
					setCurrent(currentVal ? Number(currentVal) : 0);
				}
			}
		});

		// Start observing changes to the `src` attribute
		observer.observe(imageElement, { attributes: true });

		// Cleanup observer when component unmounts
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		const imageElement = document.getElementById('carousel-image');

		if (!imageElement) return;

		// Create a MutationObserver to listen for changes to the `src` attribute
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.attributeName === 'currentpage') {
					const currentVal = imageElement.getAttribute('currentpage');
					setCurrentpage(currentVal ? Number(currentVal) : 0);
				}
			}
		});

		// Start observing changes to the `src` attribute
		observer.observe(imageElement, { attributes: true });

		// Cleanup observer when component unmounts
		return () => observer.disconnect();
	}, []);

	return (
		<>
			<div className={classes.next} onClick={() => nextHandler()}>
				<ChevronRight className={classes.arrow} />
			</div>
			{current !== 0 && (
				<div className={classes.previous} onClick={() => previousHandler()}>
					<ChevronLeft className={classes.arrow} />
				</div>
			)}
		</>
	);
};

export default ChevronCarousel;
